<script setup>
import {
  WAutocomplete,
  WLabel,
  WModal,
  WParagraph,
  WTextarea
} from '@alice-health/wonderland-vue'
import { computed, onMounted, ref, watch } from 'vue'

import { LoadingComponent } from '@/components/shared/atoms'

const emit = defineEmits(['onClose', 'loadZendeskAssignmentTags'])

const props = defineProps({
  zendeskAssignmentTags: {
    type: Object,
    required: true
  }
})

onMounted(() => {
  loadZendeskAssignmentTags()
})

const loadZendeskAssignmentTags = () => {
  emit('loadZendeskAssignmentTags')
}

const isLoading = computed(() => {
  return !props.zendeskAssignmentTags
})

const isFormInvalid = computed(() => {
  return !selectedValue.value || !context.value
})

let availableTags = []
const selectedValue = ref(undefined)
const context = ref(undefined)

const onSelectedValueChanged = event => {
  const description = event.detail
  selectedValue.value = props.zendeskAssignmentTags.availableTags.find(
    tag => tag.description === description
  )
}

const handleOnClose = event => {
  emit('onClose', event, selectedValue.value, context.value)
}

watch(
  () => props.zendeskAssignmentTags,
  tags => {
    availableTags =
      tags?.availableTags
        ?.filter(tag => tag.channelTag != 'triagem_problema_sugestao_final')
        .map(tag => tag.description) ?? []
    selectedValue.value = tags?.selected
  },
  { immediate: true }
)
</script>

<template>
  <WModal
    id="modal"
    opened
    title="Redirecionar chat para N2"
    confirm-label="Solicitar Redirecionamento"
    cancel-label="Cancelar"
    dismiss
    :invalid="isFormInvalid"
    @w-closed="handleOnClose"
  >
    <LoadingComponent :loading="isLoading">
      <div class="modal-expand__container">
        <WParagraph>
          Preencha os campos obrigatórios abaixo. Após N2 assumir o atendimento,
          você será removido do canal automaticamente.
        </WParagraph>
        <div class="modal-expand__field">
          <WLabel size="large">Motivo</WLabel>
          <WAutocomplete
            :items="availableTags"
            :value="selectedValue?.description"
            @w-select="onSelectedValueChanged"
          />
        </div>
        <WTextarea
          v-model="context"
          label="Contexto"
          placeholder="Escreva o contexto do caso para N2"
          rows="4"
          required
        />
      </div>
    </LoadingComponent>
  </WModal>
</template>

<style lang="scss" scoped>
.modal-expand {
  &__container {
    display: flex;
    flex-direction: column;
    gap: var(--gl-spacing-06);
    justify-content: space-between;
    max-width: 540px;
  }

  &__field {
    display: flex;
    flex-direction: column;
  }
}
</style>
